import { NA_VALUE } from '@yme/common/constants';
import { ENABLED_FOR_TEST_RIDE_ATTR } from '@yme/common/selectors';
import { getDealerAddress } from '@yme/organisms/preferred-dealer/helpers';
import { ABB_PRODUCT_NAME_LOCALIZED_KEY } from '@yme/selectors/constants';
import { getAttributesValueByLangOption } from '@yme/selectors/helpers';
import { getAttributeByName, getValueOptionByLang } from '@yme/utils/common';
import { DEFAULT_LANG } from '@yme/utils/constants';
export function isTestRideFormEmpty(props) {
    return !props.heroImage;
}
export function getDealerInfo(dealer) {
    if (!dealer) {
        return {
            name: '',
            address: '',
            phone: '',
        };
    }
    return {
        name: dealer.name,
        address: getDealerAddress(dealer),
        phone: dealer.telephoneNumbers[0],
    };
}
const getDealerVariants = (demoUnitsDealersId, dealerListFromUrl) => demoUnitsDealersId.filter((element) => dealerListFromUrl.includes(element));
export const getDealersIdList = ({ isInIframe, dealerIdList, dealersIdFromResponse, }) => {
    if (!isInIframe && dealerIdList.length) {
        return getDealerVariants(dealersIdFromResponse, dealerIdList);
    }
    return dealersIdFromResponse;
};
export const setDemoUnitsForDealerIds = (dealersIds, successCallback, errorCallback) => {
    if (dealersIds.length) {
        successCallback([...new Set(dealersIds)]);
    }
    else {
        errorCallback(true);
    }
};
export function flattenProducts(productData) {
    let allProducts = [];
    for (const key in productData) {
        if (productData.hasOwnProperty(key)) {
            allProducts = allProducts.concat(productData[key]);
        }
    }
    return allProducts;
}
export const getVariationsProduct = (variantsProduct, dealerIdList, isInIframe, language = DEFAULT_LANG) => {
    const powerPossibleOptions = [];
    const transmissionPossibleOptions = [];
    const loweredVersionPossibleOptions = [];
    const variants = variantsProduct.map(({ sku, attributes, dealersId, master }) => {
        const { power, transmission, loweredVersion } = getAttributesValueByLangOption({
            attributes,
            language,
        });
        powerPossibleOptions.push(power);
        transmissionPossibleOptions.push(transmission);
        loweredVersionPossibleOptions.push(loweredVersion);
        return {
            sku,
            power,
            transmission,
            loweredVersion,
            dealersId: getDealersIdList({
                isInIframe,
                dealerIdList,
                dealersIdFromResponse: dealersId,
            }),
            master,
        };
    });
    return {
        powerPossibleOptions: [...new Set(powerPossibleOptions.filter((item) => item !== NA_VALUE))],
        transmissionPossibleOptions: [
            ...new Set(transmissionPossibleOptions.filter((item) => item !== NA_VALUE)),
        ],
        loweredVersionPossibleOptions: [
            ...new Set(loweredVersionPossibleOptions.filter((item) => item !== NA_VALUE)),
        ],
        variants,
    };
};
export const getLocaleNameByAttributeKey = (variants, attributeKey, defaultValueEn, language) => {
    const targetVariant = variants.find((variant) => {
        const attributeValue = getAttributeByName(variant.attributes, attributeKey);
        return attributeValue?.en === defaultValueEn;
    });
    const attribute = getAttributeByName(targetVariant?.attributes ?? [], attributeKey);
    const value = getValueOptionByLang(attribute, language) ?? '';
    return value;
};
export const getDealersForVariants = (variants, demoUnits) => variants.map((variant) => {
    const isTestRideAvailableCT = getAttributeByName(variant.attributes, ENABLED_FOR_TEST_RIDE_ATTR);
    let dealersId = [];
    if (isTestRideAvailableCT) {
        dealersId = demoUnits[variant.sku]?.map((dealer) => dealer.dealerId) ?? [];
    }
    return {
        ...variant,
        dealersId,
    };
});
export const getDealersList = (dealers, dealersIdForVariations, isInIframeError, isShowMotorcyclesFilters) => {
    if (isInIframeError) {
        return [];
    }
    if (isShowMotorcyclesFilters) {
        return dealers.filter((dealer) => dealersIdForVariations.includes(dealer.vicinityId));
    }
    return dealers;
};
export const getTitleProductCard = (product) => {
    const masterVariant = product?.variants.find((variant) => variant.master);
    return masterVariant
        ? getAttributeByName(masterVariant.attributes, ABB_PRODUCT_NAME_LOCALIZED_KEY)
        : '';
};
export const getIsSomeVariantEnabledForTestRide = (variants) => variants.some((variant) => variant.attributes.find((attr) => attr.name === ENABLED_FOR_TEST_RIDE_ATTR && attr.value));
export const getCurrentDemoUnits = (demoUnits, productVariantsByCode, modelSku = '', isShowMotorcyclesFilters) => {
    if (isShowMotorcyclesFilters) {
        return productVariantsByCode?.hasOwnProperty(modelSku) ? productVariantsByCode[modelSku] : [];
    }
    return demoUnits;
};
